import cx from 'classnames'
import NextLegacyImage from 'next/legacy/image'

import { type SanityFrameBuilderImage } from '../../data/sanity/queries/types/image'
import { getImageDimensions, sanityImageLoader } from '../../lib/image'

interface PhotoProps {
  image: SanityFrameBuilderImage
  className?: string
}

const Photo = ({ image, className }: PhotoProps) => {
  if (!image?.asset) {
    return null
  }

  const source = JSON.stringify(image)
  const dimensions = getImageDimensions(image)

  return (
    <figure className={cx(className, 'photo-figure')}>
      <NextLegacyImage
        src={source}
        loader={sanityImageLoader}
        width={dimensions?.width}
        height={dimensions?.height}
        alt={image.alt ?? ''}
        className="block overflow-hidden"
      />
    </figure>
  )
}

export default Photo
